import { useEffect, useRef, useState } from "react";

export const LIVE_EVENT = "wn:live";
export const LIVE_MS = 30000;
export const CHANGED_EVENT = "wn:changed";
export const pingLive = (changed = false) => {
  window.dispatchEvent(new Event(LIVE_EVENT));
  if (changed) window.dispatchEvent(new Event(CHANGED_EVENT));
};

export function useLive(cb: () => void) {
  const ref = useRef(cb);
  ref.current = cb;
  useEffect(() => {
    const h = () => ref.current();
    window.addEventListener(LIVE_EVENT, h);
    return () => window.removeEventListener(LIVE_EVENT, h);
  }, []);
}

export function useLiveTick() {
  const [tick, setTick] = useState(0);
  useLive(() => setTick((n) => n + 1));
  return tick;
}
